var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 223.19 305.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.76 25.2c10.28 0 13.3 5 13.3 11.06v235.87A11.08 11.08 0 0 1 190 283.2H33.2a11.08 11.08 0 0 1-11.07-11.07V36.26A11.08 11.08 0 0 1 33.2 25.2h1.58V3.05H33.2A33.24 33.24 0 0 0 0 36.26v235.87a33.24 33.24 0 0 0 33.2 33.2H190a33.24 33.24 0 0 0 33.2-33.2V36.26c0-18.3-12.06-33.2-35.3-33.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.48 121.65s12.57-10 17-13.24c19.1-14.06 31-27.26 31-43.62 0-16.7-9-26-30.38-26a157.15 157.15 0 0 0-43.84 6.67l6-39.07C72.9 3 90.72 0 115.76 0c38 0 61.45 22 61.45 59.43 0 24.37-7.24 44-32.73 64.45-3.73 3-13.92 13.13-13.92 13.13l1.88 32.83H89.37zm28.36 68c21.37 0 32.4 10.34 32.4 29 0 19.36-11 29.38-32.06 29.38-19.7 0-31.73-10.34-31.73-29 0-19.03 12.36-29.37 31.4-29.37z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.b47c8c2c937f7cbcee8777d5b55ab399.svg";
export { ForwardRef as ReactComponent };